(function($) {

    var gridItem = $('.js-team-toggle');
    var gridOverlayClose = $('.js-overlay-close');
    var gridMeme = $('.js-meme-toggle');

    //Grid item
    gridItem.on('click', function(e) {
        e.preventDefault();
        var overlayToggle = $(this).attr('data-target');
        var headerHeight = $('.site-header').outerHeight();
        $this = $(this);

        $('html, body').animate({
            scrollTop: $this.closest('.team-block').offset().top - headerHeight
        }, 750);

        $this.addClass('is-active');
        $this.closest('.team-block').addClass('is-active');
        $('#' + overlayToggle).addClass('is-active').attr('aria-hidden', 'false');
        $('#' + overlayToggle).find('.team-meme').addClass('is-animated');
    });

    //Collapse team overlay
    gridOverlayClose.on('click', function() {
        $this = $(this);

        $this.closest('.team-overlay').removeClass('is-active').attr('aria-hidden', 'true');
        $this.closest('.team-block').removeClass('is-active');

        setTimeout(
            function() {
                $('.team-meme').removeClass('is-animated');
        }, 200);
    });

    //Add active class to meme on mouseover
    gridMeme.on('mouseover', function() {
        $(this).addClass('is-active');
    });

    //Remove active class to meme on mouseover
    gridMeme.on('mouseout', function() {
        $(this).removeClass('is-active');
    });

}(jQuery));
